// extracted by mini-css-extract-plugin
export default {"frameContainer":"styles_frameContainer__bqeAL","innerSquare":"styles_innerSquare__qQDTD","downArrow":"styles_downArrow__zSzxw","upArrow":"styles_upArrow__okHVX"};